import { render, staticRenderFns } from "./retail-billing-printing.vue?vue&type=template&id=4b970548"
import script from "./retail-billing-printing.vue?vue&type=script&lang=ts"
export * from "./retail-billing-printing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports